module.exports = __webpack_public_path__ + "materialdesignicons-webfont.b8695cc16b97f1bd9744.eot";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.eot?v=1.8.36
// module id = ../../../../../src/scss/icons/material-design-iconic-font/fonts/materialdesignicons-webfont.eot?v=1.8.36
// module chunks = styles